/****************************************************
 * Module Name:  stockTallyProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class StockTallyProxy {

    static GetAllStockByLocation = (locationid, data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/stonetally/stock/${locationid}`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllStockForGrading = (locationid, data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/stonetally/grading/${locationid}`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllProformaByLocation = (type, locationid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/stonetally/proforma/${type}/${locationid}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllStoneTransit = (type, locationid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/stonetally/transit/${type}/${locationid}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static updateProformaTallyStatus = (userId, type, locationId, data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/stonetally/proforma/${type}/${locationId}/${userId}`,
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static CancelLocationTransfer = (locationId, data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/stonetally/locationtransfer/${locationId}`,
            "delete",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllLocationTransferStone = (type, locationid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/stonetally/locationtransfer/${type}/${locationid}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static updateLocationTransferStatus = (userid, listData, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/stonetally/locationtransfer/${userid}`,
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(listData),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllManufacturingTransferStone = (type, locationid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/stonetally/manufacturing/${type}/${locationid}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetConfiguredBoxLocations = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/stocktally/detail/mini",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetStockTally = (data, ondate, callback) => {
        let params = {
            ondate: ondate
        }
        restAPICall(
            Constants.MANAGER_URL + `/stocktally`,
            "post",
            Constants.userToken,
            params,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static sendTallyNotification = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/stocktally/notify`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdateTag = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/stonetally/tag`,
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdateGradingStone = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/stonetally/grading`,
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

}